<template>
    
    <v-container v-if="getLanguageList" class="pa-2" fluid grid-list-sm > 
    <div v-if="needInit">{{initData()}}</div>   
    
       <v-layout row wrap>        
            <v-flex xs6> <v-card outlined >  
                <language-list v-bind:ltype="1"></language-list>
                <a-category v-bind:ltype="1"></a-category>
            </v-card>  </v-flex>
            <v-flex xs6> <v-card outlined >   
                <language-list v-bind:ltype="2"></language-list>
                <a-category v-bind:ltype="2"></a-category>
            </v-card>  </v-flex>
            <v-flex xs12>
                 <v-layout row wrap>
                   <v-card outlined >
                       <v-card-title class="layout justify-center">Category color:</v-card-title>
                       <v-card-text class="layout justify-center">
                                <v-color-picker
                                    v-model="mycolor"     
                                ></v-color-picker>
                       </v-card-text>
                   </v-card>
                 </v-layout>
            </v-flex>
            <v-flex xs12>
                <v-card>
                    <p></p>
                    <p v-if="getRefresh1 || getRefresh2">Preparing...</p>
                    <p v-if="getPreparedforSave && runSaving">{{saveData()}}</p>                    
                    <v-layout align-end justify-space-between row fill-height>
                        <v-flex xs4></v-flex>
                            <v-flex xs6>
                                <v-card outlined>
                                    <v-btn @click="saveAndClose">Save and close</v-btn>
                                    <v-btn @click="closeForm">Close without saving</v-btn>                    
                                </v-card>
                            </v-flex>
                    </v-layout>
                    <p></p>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import ACategory from '../../../elements/ACategory.vue'
import LanguageList from '../../../elements/LanguageList.vue'
import {mapGetters} from 'vuex'
import axios from '../../../../axios-auth.js'

export default {
    data() {
        return {    
             runSaving: false,
             closeAfterSaving: false,
             contentUni: null,
             needInit : true,
             order: 0,
             ID: 0,
             mycolor: '#8E00FF'
        }
    },
    computed: 
        mapGetters([
                        'getRefresh1',
                        'getRefresh2',
                        'getAllContentUni',
                        'getLanguagePrimary',
                        'getLanguageSecondary',
                        'getPreparedforSave',
                        'getAxiosConfig',
                        'getLanguageList'
                    ])
    ,
    components: {
        ACategory,
        LanguageList
    },
    methods : {
        prepareDataforSave() {
            this.runSaving = true
            // saved data with temporary lang - set it to main lang
            this.$store.commit('setLangPrimaryTmp',this.getLanguagePrimary)
            this.$store.commit('setLangSecondaryTmp',this.getLanguageSecondary)

            this.$store.commit('setPreparedforSave',false)
            // send notification for save to store
            this.$store.commit('setRefresh1',true)
            this.$store.commit('setRefresh2',true)
        },
        saveData() {
            this.runSaving = false
            // prepare data for json
            this.$store.commit('setFeedback', null)
            const data = this.getAllContentUni
            
            this.contentUni = {
                category_id: this.ID,
                category_order: this.order,
                color: this.mycolor,
                content_list: []
            }

            for(var key in data) {
                this.contentUni.content_list.push( {
                    lang_id : key.replace('l',''),
                    content :  data[key]
                })
            }

            // axios
            axios.post('/create-edit-category-all-lang', this.contentUni, this.getAxiosConfig)
            .then(() => {    
                if (this.closeAfterSaving) this.closeForm()
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)
            })      
        },
        //*********************************************************************** */
        saveAndClose() {
            this.closeAfterSaving = true
            this.prepareDataforSave()            
        },
        closeForm() {
            this.$router.push({name:'categories', params: {}})   
        },
        initData() {    
            this.needInit = false
            this.$store.commit('setFeedback', null)
            // saved data with temporary lang - set it to main lang
            this.$store.commit('setLangPrimaryTmp',this.getLanguagePrimary)
            this.$store.commit('setLangSecondaryTmp',this.getLanguageSecondary)

            this.ID = this.$route.params.id

            if (this.$route.params.id == '0') {
                this.$store.commit('prepareUni','default')
            } else { 
            // load existing data
                axios.get('/get-category-in-all-lang/' + this.ID, this.$store.getters.getAxiosConfig )
                .then(res => {
                    const data = {                        
                        cType: 'default',
                        content_list : res.data.list
                    }
                    if (res.data.color == null) this.mycolor = "#AAAAAA"
                    else  this.mycolor = res.data.color
                    this.order = res.data.category_order
                    this.$store.dispatch('setFullContentUni', data)                    
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })
            } 
        }
    },
    mounted() {        
        this.needInit = true
    }      
     
}
</script>


